import * as actions from './actions';

export const tag = (state = { tags: [] }, action) => {
  switch (action.type) {
    case actions.GET_TAGS:
      return Object.assign({}, state, { tags: action.tags });
    default:
      return state;
  }
};

export const pdpModal = (state = { visible: false, product: null }, action) => {
  switch (action.type) {
    case actions.TOGGLE_PDP_MODAL:
      return Object.assign({}, state, {
        visible: !state.pdpModalVisible,
        product: action.product,
      });
    default:
      return state;
  }
};
